var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('resource-languages',{attrs:{"resource_type":"Position","resource_id":_vm.payload.position_id,"resource_data":_vm.payload.position_data,"languages":_vm.languages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }